import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import {
  createDeploymentInchargeMaster,
  getAllSecondaryDeploymentInchargeMaster,
  updateDeploymentInchargeMaster,
} from "../../Apis/secondaryDeploymentCharge";
import { useForm } from "react-hook-form";
import { getAllDeploymentLocationMaster } from "../../Apis/deployLocationMasterApi";
import { toast } from "react-toastify";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
import TableSkeleton from "../AllotedMaster/TableSkeleton";
const SecondaryDeploymentChargeMaster = ({ t }) => {
  const [lgShow, setLgShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const headers = [
    "InchargeName",
    "mobileNumber",
    "emailId",
    // "associatedDeploymentLocationId",
    "LocationName",
    "status",
    "actions",
  ];
  const [inchargeData, setInchargeData] = useState([]);
  const [editInchargeData, setEditInchargeData] = useState("");
  const [editInchargeId, setEditInchargeId] = useState(null);
  const [selectedIncharge, setSelectedIncharge] = useState(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalSDInchargeData, setFilterOriginalSDInchargeData] = useState([]);
  const [formInput, setFormInput] = useState({
    secondaryDeploymentInchargeName: "",
    mobileNumber: "",
    emailId: "",
    password: "",
    // isActive: "",
    secondaryDeploymentInchargeId: "",
    isActive: true,
    associatedDeploymentLocationId: ""
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [options, setOptions] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const resetFields = (reset) => {
    setFormInput({
      secondaryDepInchargeName: "",
      mobileNumber: "",
      emailId: "",
      // password: "",
      zoneId: "",
      wardId: "",
      circleId: "",
      associatedDeploymentLocationId: "",
      secondaryDeploymentInchargeId: "",
      isActive: "",
      // deployment_location_id: "",
      // primaryDeploymentInchargeId: "",
    });
    resetRef.current();
  };

  const resetRef = useRef(null);

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedIncharge(null);
    setFormSubmitted(false);
  };

  const fetchIncharge = async () => {
    try {
      const response = await getAllSecondaryDeploymentInchargeMaster();
      const locationResponse = await getAllDeploymentLocationMaster();
      const inchargeDataResponse = response.map((incharge) => {
        const matchedLocation = locationResponse.find(location => location.secondaryDeploymentLocationId === incharge.associatedDeploymentLocationId);
        const secondaryDeploymentLocationName = matchedLocation ? matchedLocation.secondaryDeploymentLocationName : "";
        return {
          ...incharge,
          InchargeName: incharge.secondaryDeploymentInchargeName,
          mobileNumber: incharge.mobileNumber,
          LocationName: secondaryDeploymentLocationName,
          status: incharge.isActive ? "Active" : "InActive",
        };
        // ...incharge,
        // secondaryDeploymentIncharge: incharge.secondaryDeploymentInchargeName
      })


      // Sort the data based on the isActive field
      const sortedInchargeData = inchargeDataResponse.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setInchargeData(sortedInchargeData);
      setFilterOriginalSDInchargeData(sortedInchargeData);
      setIsOptionsLoading(false);
      setOriginalData(inchargeDataResponse);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditIncharge = async (selectedInchargeData) => {
    setEditInchargeData(selectedInchargeData);
    setEditInchargeId(selectedInchargeData.id);
    setSelectedIncharge(selectedInchargeData);
    setLgShow(true);
    setIsOptionsLoading(true)
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setFormInput({
      ...formInput,
      secondaryDeploymentInchargeName: selectedInchargeData.secondaryDeploymentInchargeName,
      associatedDeploymentLocationId: selectedInchargeData.associatedDeploymentLocationId,
      mobileNumber: selectedInchargeData.mobileNumber,
      emailId: selectedInchargeData.emailId,
      isActive: selectedInchargeData.isActive,
      secondaryDeploymentInchargeId: selectedInchargeData.secondaryDeploymentInchargeId,
    });
    try {
      // const circlesData = await GetCirclebyID(zoneId);
      // setAllCircles(circlesData);
      // const wardsData = await GetWardsbyCircleId(circleId);
      // setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching circles and wards data:", error);
    }
    reset();
  };

  const addNewIncharge = async (data) => {

    try {
      setFormSubmitted(true);
      const {
        secondaryDeploymentInchargeName,
        associatedDeploymentLocationId,
        mobileNumber,
        emailId,
        isActive,
        secondaryDeploymentInchargeId,
      } = formInput;
      // Validate required fields
      if (
        !secondaryDeploymentInchargeName ||
        !associatedDeploymentLocationId ||
        !mobileNumber ||
        !emailId
      ) {
        // Display toast message indicating the required field
        console.error('please fill all the fields')
        // Stop further execution
        return;
      }

      //  const firstDigit = formInput.mobileNumber.charAt(0);
      // const mobileNumberPattern = /^[6-9]\d{9}$/;
      //   // if (
      //   //   !formInput.transferStationInchargeName ||
      //   //   !formInput.associatedTransferStationIds.length ||
      //   //   !formInput.emailId ||
      //   //   !formInput.mobileNumber
      //   // ) 
      //   // {
      //   //   // Display toast message indicating the required field
      //   //   // toast.error("Please fill out all required fields", {
      //   //   //   position: "top-right",
      //   //   //   autoClose: 5000,
      //   //   //   hideProgressBar: false,
      //   //   // });
      //   //   // Stop further execution
      //   //   return;
      //   // }
      //   const isDuplicateEmail = secondaryDeploymentInchargeId.some(
      //     (incharge) =>
      //       incharge.emailId === formInput.emailId &&
      //       incharge.id !== selectedIncharge?.id // Exclude the current edited incharge if any
      //   );

      //   if (isDuplicateEmail) {
      //     toast.error("Email ID already exists. Please choose a different one.", {
      //       position: "top-right",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //     });
      //     return;
      //   }
      //   // if (!mobileNumberPattern.test(formInput.mobileNumber)) {
      //   //   toast.error("Invalid mobile number. It should start with 6, 7, 8, or 9 and be 10 digits long.", {
      //   //     position: "top-right",
      //   //     autoClose: 5000,
      //   //     hideProgressBar: false,
      //   //   });
      //   //   return;
      //  // }
      //   {
      //     setIsOptionsLoading(true);
      //     await new Promise((resolve) => setTimeout(resolve, 1000));
      //     // Add your form submission logic here, for example:
      //     // const response = await submitForm(formInput);
      //     // handle the response accordingly
      //     setIsOptionsLoading(false);
      //   }

      // const secondaryDeploymentInchargeName = data.secondaryDeploymentInchargeName || "";
      // const associatedDeploymentLocationId = data.associatedDeploymentLocationId || "";
      // const mobileNumber = data.mobileNumber || "";
      // const emailId = data.emailId || "";
      // const secondaryDeploymentInchargeId = data.secondaryDeploymentInchargeId || "";
      // // const isActive = selectedIncharge ? formInput.isActive : true;
      // const isActive = data.isActive || '';
      // if (
      //   !formInput.secondaryDeploymentInchargeName
      //   || !formInput.mobileNumber
      //   || !formInput.emailId
      //   || !formInput.associatedDeploymentLocationId
      //   // || !formInput.isActive
      // ) {
      //   // Display toast message indicating the required field
      //   // toast.error("Please fill out all required fields", {
      //   //   position: "top-right",
      //   //   autoClose: 5000,
      //   //   hideProgressBar: false,
      //   // });
      //   // Stop further execution
      //   return;
      // }
      // new

      const requestData = {
        secondaryDeploymentInchargeName,
        associatedDeploymentLocationId,
        mobileNumber,
        emailId,
        isActive,
        secondaryDeploymentInchargeId,
      };
      if (selectedIncharge) {
        const res = await updateDeploymentInchargeMaster(
          selectedIncharge.secondaryDeploymentInchargeId,
          requestData
        );
        // console.log(res, 'from update function')
        const successMessage = "Secondary Deployment InCharge Updated Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchIncharge();
        reset();
        handleClose();
      } else {
        const res = await createDeploymentInchargeMaster(requestData);
        // console.log(res, 'res from add')
        const successMessage = "Secondary Deployment InCharge Added Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        reset();
        fetchIncharge();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 400) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
        else if (status === 404) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }

    } finally {
      setIsOptionsLoading(false)
    }
  };


  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(addNewIncharge);
    }
  };

  useEffect(
    () => {
      fetchIncharge();
      if (editInchargeId) {
        // fetchCirclesAndWards(editInchargeData.zoneId);
      }
    },
    []
  );

  const fetchLocation = async () => {
    try {
      const response = await getAllDeploymentLocationMaster();
      if (response && response.length > 0) {
        setOptions(response);
      } else {
        setOptions([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchIncharge();
    fetchLocation();
  }, []);

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true)
    setFormInput({
      secondaryDeploymentInchargeName: "",
      mobileNumber: "",
      emailId: "",
      password: "",
      secondaryDeploymentInchargeId: "",
      isActive: true,
      associatedDeploymentLocationId: ""
    })
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };


  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };



  const options2 = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options2).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Secondary Deployment Incharge Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SecondaryDeploymentIncharge");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Secondary Deployment Incharge" title
    worksheet.addRow(["", "", "Secondary Deployment Incharge", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Secondary Deployment Incharge";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font (excluding the 'actions' column)
    const tableHeaderRow = worksheet.addRow([
      "S.No", // S.No
      "Incharge Name", // Secondary Deployment Incharge
      "Mobile Number",
      "Email Id", // Email Id
      "Location Name", // Secondary Deployment Location
      "Status" // Status
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Align to the left
      if (colNumber >= 1 && colNumber <= 6) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    // Add data rows (exclude 'actions' column)
    dataToUse.forEach((item, index) => {
      worksheet.addRow([
        index + 1, // S.No (index + 1)
        item.secondaryDeploymentInchargeName, // Secondary Deployment Incharge
        item.mobileNumber,
        item.emailId, // Email Id
        item.LocationName, // Secondary Deployment Location
        item.status // Status
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 6) {
          // Align the columns from 1 to 5 to the left
          cell.alignment = { horizontal: "left" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 }, // Width for "S.no"
      { width: 30 }, // Width for "Secondary Deployment Incharge Name"
      { width: 30 },
      { width: 30 }, // Width for "Email Id"
      { width: 30 }, // Width for "Secondary Deployment Location"
      { width: 15 }, // Width for "Status"
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SecondaryDeploymentInchargeDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let sanitizedValue = value; // Initialize sanitized value with the input value

    if (name === "mobileNumber") {
      // Remove any non-numeric characters
      sanitizedValue = value.replace(/\D/g, '');
    
      // Check if the first digit is 0-5 and clear the value if invalid
      if (/^[0-5]/.test(sanitizedValue)) {
        sanitizedValue = "";
      } else {
        // Limit to 10 digits
        sanitizedValue = sanitizedValue.slice(0, 10);
      }
    }
    
    // Update the state based on the field name
    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));

    if (name === "mobileNumber") {
      const firstDigit = sanitizedValue.charAt(0);
      if (!["6", "7", "8", "9"].includes(firstDigit)) {
        // Show error message or handle invalid format
        // For now, I'm just logging an error message
        console.error("Mobile number must start with 6, 7, 8, or 9");
      }

    };
  }

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 27;

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }
  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...inchargeData].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const searchSecondaryDeploymentInchargeHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalSDInchargeData.filter(item => item?.secondaryDeploymentInchargeName?.toLowerCase()?.includes(term))
    setInchargeData(data);
  }
  const searchMobileNumberHandler = (e) => {
    const term = e.target.value.trim(); // Get the search term and trim any spaces

    // Filter data based on mobile number
    const data = filterOriginalSDInchargeData.filter(item =>
      item?.mobileNumber?.includes(term) // Check if the mobile number includes the term
    );

    setInchargeData(data); // Update the state with filtered data
  };


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">{t("Secondary Deployment Incharges")}</h4>
            <div className="row mt-3  align-items-center">
              <div className="col-md-3">
                <input
                  placeholder="Search Secondary Deployment Incharges"
                  type="text"
                  className="form-control bg-white"
                  onInput={searchSecondaryDeploymentInchargeHandler}
                />
              </div>
              <div className="col-md-3">
                <input
                  placeholder="Search by Mobile Number"
                  type="text"
                  className="form-control bg-white"
                  onInput={searchMobileNumberHandler}
                />
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-end">
                  {canWriteValue === true ?
                    <button className="button-container ms-auto" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t('Add SD Incharge')}
                    </button>
                    : ''}
                  <button className="btn btn-excel"
                    onClick={handleSortAndExport}>
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
                </div>
              </div>
            </div>




            <div className="card mt-3">
              <div className="card-body">
               { isOptionsLoading?<TableSkeleton/>:
                <TableComponent
                  DataFetchURL={inchargeData}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditIncharge}
                  editInchargeData={editInchargeData}
                  onSort={handleSort}
                // viewData={(id) => handleViewInchargeData(id)}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        // centered
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {selectedIncharge ? "Edit Secondary Deoployment InCharge" : "Add Secondary Deployment InCharge"}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewIncharge)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit);
            }}
          >
            <div className="row">
              {/*{selectedIncharge ? (*/}
              <div className="col-md-4 " style={{ display: 'none' }}>
                <div className="form-group">
                  <label className="form-label">ID</label>
                  <input
                    type="number"
                    className="form-control"
                    name="secondaryDeploymentInchargeId"
                    {...register("secondaryDeploymentInchargeId")}
                    value={formInput.secondaryDeploymentInchargeId}
                    readOnly
                    onChange={(e) =>
                      setFormInput({ ...formInput, secondaryDeploymentInchargeId: e.target.value })
                    }
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* ) : (
                ""
              )}*/}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Incharge Name<span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    placeholder="Enter Incharge Name"
                    maxLength={42}
                    name="secondaryDeploymentInchargeName"
                    className={`form-control ${formInput.secondaryDeploymentInchargeName || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("secondaryDeploymentInchargeName")}
                    value={formInput.secondaryDeploymentInchargeName}
                    onChange={(e) => {
                      let sanitizedValue = e.target.value

                      .slice(0, 25) // Limit to 25 characters
                      .replace(/[^A-Za-z ]/g, '')
                      .replace(/^\s+/, "") // Remove leading spaces
                      .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
                      setFormInput({
                        ...formInput,
                        secondaryDeploymentInchargeName: sanitizedValue,
                      })
                    }}
                    disabled={!canWriteValue}
                  />
                  {!formInput.secondaryDeploymentInchargeName && formSubmitted && (
                    <div className="required-message small">
                      Secondary Deployment Incharge Name is  Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Mobile Number<span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    //  type="number"
                    placeholder="Enter Mobile Number"
                    name="mobileNumber"
                    pattern="[0-9]{10}" // Specify the pattern for 10 digits
                    title="Mobile number must be exactly 10 digits long."
                    className={`form-control ${formInput.mobileNumber || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("mobileNumber")}
                    value={formInput.mobileNumber}
                    min={0}
                    onInput={(e) => {
                      const maxLength = 10;
                      if (e.target.value.length > maxLength) {
                        e.target.value = e.target.value.slice(0, maxLength);
                      }
                    }}
                    onChange={handleInputChange}
                    disabled={!canWriteValue}
                  />
                  {!formInput.mobileNumber && formSubmitted && (
                    <div className="required-message small">
                      Mobile Number is Required
                    </div>
                  )}

                  {formInput.mobileNumber && formInput.mobileNumber.length !== 10 && formSubmitted && (
                    <div className="required-message small">
                      Mobile number must be 10 digits
                    </div>
                  )}
                  {/* {formInput.mobileNumber.length !== 10 && formSubmitted && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      Mobile number must be exactly 10 digits long.
                    </span>
                  )} */}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Email ID<span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="email"
                    placeholder="Enter Email ID"
                    name="emailId"
                    className={`form-control ${formInput.emailId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("emailId")}
                    value={formInput.emailId}
                    onChange={(e) =>
                      setFormInput({ ...formInput, emailId: e.target.value })
                    }
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.emailId && formSubmitted && (
                    <div className="required-message small">
                      Email ID is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">Secondary Deployment Location Name<span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    className={`form-select ${formInput.associatedDeploymentLocationId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("associatedDeploymentLocationId")}
                    value={formInput.associatedDeploymentLocationId}
                    name="associatedDeploymentLocationId"
                    onChange={(e) => {
                      setFormInput({
                        ...formInput,
                        associatedDeploymentLocationId: e.target.value,
                      });
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="">select</option>
                    {options
                      .filter((location) => location.isActive)
                      .map((location) => (
                        <option
                          key={location.secondaryDeploymentLocationId}
                          value={location.secondaryDeploymentLocationId}
                        >
                          {location.secondaryDeploymentLocationName}
                        </option>
                      ))}
                  </select>
                  {!formInput.associatedDeploymentLocationId && formSubmitted && (
                    <div className="required-message small">
                      Secondary Deployment Location Name is  Required
                    </div>
                  )}
                </div>
              </div>
              {/* {selectedIncharge ? ( */}
              <div className="col-md-4">
                <label className="form-label">Status <span style={{ color: '#EC1117' }}> *</span></label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      {...register('isActive')}
                      value="true"
                      checked={formInput.isActive === true}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "1" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      {...register('isActive')}
                      value="false"
                      checked={formInput.isActive === false}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "0" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {selectedIncharge ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(SecondaryDeploymentChargeMaster);